module.exports = __webpack_public_path__ + "img/dash-card-pending-approval.42e0de8d.svg";